import styles from './style.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import drawing_png from "../../../assets/drawing.png";
import map from "../../../assets/map.svg";
import {  Popover  } from 'newmaterial-ui';
import clsx from 'clsx';
import { MonitoringHandleActiveDrivers, MonitoringHandleActiveOrders, MonitoringSetDriversBusyFree, MonitoringSetOrdersPickupDelivery } from '../../../Redux/actions/actionNames';
import { useTranslation } from 'react-i18next';
import { getOrderMonitoring } from './action/getOrderMonitoring';
import { getDriverMonitoring } from './action/getDriverMonitoring';
import { useGetFiltersList } from '../../../hooks/useGetFiltersList';
import { useGetSearchListFilter } from '../../../hooks/useGetSearchListFilter';
import Button from '../../../design-system/lib/Button';
import { DRIVER_COLOR, LOCATION } from '../../../assets';
import Checkbox from '../../../design-system/lib/Checkbox';
import Typography from '../../../design-system/lib/Typography';


export const MonitoringToolBar = () => {
    const ordersOpen = useSelector((state) => state.Monitoring.orders.open)
    const driversOpen = useSelector((state) => state.Monitoring.drivers.open)
    const [ordersInterval, setOrdersInterval] = useState(null);
    const [driversInterval, setDriversInterval] = useState(null);
    const [open, setOpen] = useState(false);
    const { t, i18n } = useTranslation();
    let { DateRange, selectedServices, selectedStatus, selectedVehicleType, isScheduled, changed, zones, now } = useGetFiltersList()
    const ActiveOrderType = useSelector((state) => state.OrderList.ActiveOrderType)
    let { regexText, ActiveregexFields } = useGetSearchListFilter()



    useEffect(() => {
      
    }, [ordersOpen, ActiveOrderType, DateRange, selectedServices, selectedStatus, selectedVehicleType, isScheduled, now, changed, zones, regexText, ActiveregexFields])


    // useEffect(() => {
    //     if(!driversOpen){
    //         return 
    //     }
    //     getDriverMonitoring()
    //     const interval = setInterval(() => {
    //         getDriverMonitoring()
    //     }, 10000);
    //     return () => clearInterval(interval);
    //   }, [driversOpen]);


    // useEffect(() => {
    //     if (driversOpen) {
    //         getDriverMonitoring()
    //         if (!driversInterval) {
    //             setDriversInterval(setInterval(() => {
    //                 getDriverMonitoring()
    //             }, 10000))
    //             return () => {
    //                 clearInterval(driversInterval)
    //               };
    //         }
    //     } else {
    //         clearInterval(driversInterval)
    //         return () => {
    //             clearInterval(driversInterval)
    //           };
    //     }
    //     return () => {
    //         clearInterval(driversInterval)
    //       };
    // }, [driversOpen])



    return <div className={styles.monitoringContainer}>

  
 
                <DriverCheckbox />
                <OrderCheckbox />
                <div style={{width:"1px" , height:"20px",backgroundColor:"black",opacity:".2"}}/>
                <MapSelection />
               
 
    </div>
};





const OrderCheckbox = ({ checked, ...props }) => {
    const ordersOpen = useSelector((state) => state.Monitoring.orders.open)
    const showPickup = useSelector((state) => state.Monitoring.orders.showPickup)
    const showDelivery = useSelector((state) => state.Monitoring.orders.showDelivery)

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [pickup, setPickup] = useState(showPickup);
    const [delivery, setDelivery] = useState(showDelivery);

    

      useEffect(() => {

       dispatch(MonitoringHandleActiveOrders(true))

      }, [ ]);


        const HandleSunc = useCallback(( ) => {
      dispatch(MonitoringSetOrdersPickupDelivery(pickup , 'showPickup'))
      dispatch(MonitoringSetOrdersPickupDelivery(delivery , 'showDelivery'))

      handleClose()

      dispatch(MonitoringHandleActiveOrders(showPickup || showDelivery))

    }, [pickup , delivery]);

      const HandleReset = useCallback(( ) => {

      dispatch(MonitoringSetOrdersPickupDelivery(true , 'showPickup'))
      dispatch(MonitoringSetOrdersPickupDelivery(true , 'showDelivery'))
       dispatch(MonitoringHandleActiveOrders(true))


      setPickup(true)
      setDelivery(true)

      handleClose()

    }, [showPickup , showDelivery]);


    // const ordersOpen = useSelector((state) => state.Monitoring.orders.open)
    // const dispatch = useDispatch();
    // const { t, i18n } = useTranslation();

    // function handleOpenCloseOrders() {
    //     dispatch(MonitoringHandleActiveOrders(!ordersOpen))
    // }


    // return (
    //     <div className={styles.popperItemFrame}>
    //         <span className={styles.popperItemText}> {t("Orders")}  </span>
    //         <input className={clsx(styles.checkboxWrapper, ordersOpen ? styles.checked : '')} type="checkbox"
    //             onClick={handleOpenCloseOrders}
    //             {...props}
    //         />
    //     </div>
    // );
     const [anchorEl, setAnchorEl] =  useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    < >
      <Button onClick={handleClick} size='Small' type='Secondary' icon={LOCATION} className={styles.btng}  style={{backgroundColor: open && "#80808033"}} text={<>{t("Order Stops")} | <span style={{color:"#242424" , fontWeight:"500"}}>{(showPickup && showDelivery) ? t("AllKey") : (showPickup ? t("Pickup2") :( (!showPickup && !showDelivery) ? t("None") : t("Delivery")))} </span></>}  />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
             style={{ marginTop: "-4px" ,
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', // تغییر باکس شادو
              }} // فاصله 16 پیکسل از بالای دکمه
              sx={{}}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        classes={{ paper: styles.Popover }}
      >
        <div className={styles.popoverContainer}>
             <span className={styles.cheConta} onClick={()=>{ setPickup(!pickup)  }}> <Checkbox size='Small' state={pickup ? 'checked' : "unchecked"}  onClick={()=>{  }}  /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={t("Pickup2")} /> </span>
             <span className={styles.cheConta}  onClick={()=>{ setDelivery(!delivery)  }}> <Checkbox size='Small' state={delivery ? 'checked' : "unchecked"}  onClick={()=>{  }} /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={t("Delivery")} /> </span>
             <span className={styles.cheConta2}>  <Typography weight='Body_Tiny_Bold' style={{color:"#242424",cursor:"pointer"}} text={t("Reset")} onClick={HandleReset} /> <Typography weight='Body_Tiny_Bold' style={{color:"#1080FF",cursor:"pointer"}} text={t("Apply")} onClick={HandleSunc} /></span>
        </div>
      </Popover>
    </ >
  );
};


const DriverCheckbox = ({ checked, ...props }) => {
    const driversOpen = useSelector((state) => state.Monitoring.drivers.open)
    const driversfree = useSelector((state) => state.Monitoring.drivers.free)
    const driversbusy = useSelector((state) => state.Monitoring.drivers.busy)

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [free, setFree] = useState(driversfree);
    const [busy, setBusy] = useState(driversbusy);

    

      useEffect(() => {
       dispatch(MonitoringHandleActiveDrivers(true))

      }, [ ]);
    // function handleOpenCloseDrivers() {
    //     dispatch(MonitoringHandleActiveDrivers(!driversOpen))
    // }

    // return (
    //     <div className={styles.popperItemFrame} style={{ marginBottom: "0" }}>
    //         <span className={styles.popperItemText}> {t("Drivers")} </span>
    //         <input className={clsx(styles.checkboxWrapper, driversOpen ? styles.checked : '')} type="checkbox"
    //             onClick={handleOpenCloseDrivers}
    //             {...props}
    //         />
    //     </div>
    // );


  const [anchorEl, setAnchorEl] =  useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const HandleSunc = useCallback(( ) => {
      dispatch(MonitoringSetDriversBusyFree(busy , 'busy'))
      dispatch(MonitoringSetDriversBusyFree(free , 'free'))

      handleClose()

      dispatch(MonitoringHandleActiveDrivers(busy || free))

    }, [busy , free]);

      const HandleReset = useCallback(( ) => {

      dispatch(MonitoringSetDriversBusyFree(true , 'busy'))
      dispatch(MonitoringSetDriversBusyFree(true , 'free'))
       dispatch(MonitoringHandleActiveDrivers(true))


      setBusy(true)
      setFree(true)

      handleClose()

    }, [busy , free]);


       useEffect(() => {
        if(!driversOpen){
            return 
        }
        getDriverMonitoring()
        const interval = setInterval(() => {
            getDriverMonitoring()
        }, 10000);
        return () => clearInterval(interval);
      }, [driversOpen]);


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    < >
      <Button onClick={handleClick} size='Small' type='Secondary' icon={DRIVER_COLOR} className={styles.btng} style={{backgroundColor: open && "#80808033"}} text={<>{t("Drivers")} | <span style={{color:"#242424" , fontWeight:"500"}}>{(driversbusy && driversfree) ? t("All") : (driversbusy ? t("Busy") :( (!driversbusy && !driversfree) ? t("None") : t("Free")))} </span></>}  />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
             style={{ marginTop: "-4px" ,
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', // تغییر باکس شادو
              }} // فاصله 16 پیکسل از بالای دکمه
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        classes={{ paper: styles.Popover }}
      >
        <div className={styles.popoverContainer}>
          <span className={styles.cheConta} onClick={()=>{ setFree(!free)  }}> <Checkbox size='Small' state={free ? 'checked' : "unchecked"}  onClick={()=>{  }}  /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={t("Free")} /> </span>
          <span className={styles.cheConta}  onClick={()=>{ setBusy(!busy)  }}> <Checkbox size='Small' state={busy ? 'checked' : "unchecked"}  onClick={()=>{  }} /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={t("Busy")} /> </span>
          <span className={styles.cheConta2}>  <Typography weight='Body_Tiny_Bold' style={{color:"#242424",cursor:"pointer"}} text={t("Reset")} onClick={HandleReset} /> <Typography weight='Body_Tiny_Bold' style={{color:"#1080FF",cursor:"pointer"}} text={t("Apply")} onClick={HandleSunc} /></span>

        </div>
      </Popover>
    </ >
  );
};



const MapSelection = ({ checked, ...props }) => {
   const DrawingRef = useSelector((state) => state.Map.drawingRef)
   const drawingRefMode = useSelector((state) => state.Map.drawingRefMode)

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [isGoogle, setIsGoogle] = useState(global.config.dispatcherSettings.applicationMap.type );
    const [indexx, setIndexx] = useState(0);

   const handleRectangle = useCallback(( ) => {

    if(isGoogle == "google" && DrawingRef){
         dispatch({type : "drawingRefMode" , state:"rectangle"})

         DrawingRef.current?.state.drawingManager?.setDrawingMode(null);
         DrawingRef.current?.state.drawingManager?.setDrawingMode("rectangle");
         setIndexx(2)
     }else if(isGoogle == "osm" && DrawingRef){
        dispatch({type : "drawingRefMode" , state:"rectangle"})

        DrawingRef?.current?.leafletElement._toolbars.draw._modes.polygon.handler.disable();
        DrawingRef?.current?.leafletElement._toolbars.draw._modes.rectangle.handler.disable();
        DrawingRef?.current?.leafletElement._toolbars.draw._modes.rectangle.handler.enable();
         setIndexx(2)

     }
 
    }, [isGoogle , DrawingRef , indexx]);

   const handlePolygon = useCallback(( ) => {

    if(isGoogle == "google" && DrawingRef){
        dispatch({type : "drawingRefMode" , state:"polygon"})

         DrawingRef.current?.state.drawingManager?.setDrawingMode(null);
         DrawingRef.current?.state.drawingManager?.setDrawingMode("polygon");
         setIndexx(1)
     }else if(isGoogle == "osm" && DrawingRef){
        dispatch({type : "drawingRefMode" , state:"rectangle"})

        DrawingRef?.current?.leafletElement._toolbars.draw._modes.polygon.handler.disable();
        DrawingRef?.current?.leafletElement._toolbars.draw._modes.rectangle.handler.disable();
        DrawingRef?.current?.leafletElement._toolbars.draw._modes.polygon.handler.enable();
         setIndexx(1)

     }
 
    }, [isGoogle , DrawingRef , indexx]);


   const handleHand = useCallback(( ) => {

    if(isGoogle == "google" && DrawingRef){
                    dispatch({type : "drawingRefMode" , state:null})

         DrawingRef.current?.state.drawingManager?.setDrawingMode(null);
         setIndexx(0)
     }else if(isGoogle == "osm" && DrawingRef){
        DrawingRef?.current?.leafletElement._toolbars.draw._modes.polygon.handler.disable();
        DrawingRef?.current?.leafletElement._toolbars.draw._modes.rectangle.handler.disable();
                 setIndexx(0)

     }
 
    }, [isGoogle , DrawingRef , indexx]);


 

     
       useEffect(() => {
       !drawingRefMode && setIndexx(0)
        }, [drawingRefMode] )
    
     

  return (
      <div className={styles.MonitoringToolBar}>
        <div className={styles[`selectedImg_${indexx}`]} />
        <div style={{position:"relative", width:'16px',height:"16px",overflow:"hidden",position:"relative"}} onClick={handleHand}>
                 <img src={drawing_png} style={{
                  position: 'absolute',
                  left: '0px',
                  top: '-144px',
                  userSelect: 'none',
                  border: '0px',
                  padding: '0px',
                  margin: '0px',
                  maxWidth: 'none',
                  width: '16px',
                  height: '192px'
              }} />
        </div>
       <div style={{position:"relative", width:'16px',height:"16px",overflow:"hidden",position:"relative"}} onClick={handlePolygon}>
                 <img src={drawing_png} style={{
                  position: 'absolute',
                  left: '0px',
                  top: '-64px',
                  userSelect: 'none',
                  border: '0px',
                  padding: '0px',
                  margin: '0px',
                  maxWidth: 'none',
                  width: '16px',
                  height: '192px'
              }} />
        </div>
              <div style={{position:"relative", width:'16px',height:"16px",overflow:"hidden",position:"relative"}} onClick={handleRectangle}>
                 <img src={drawing_png} style={{
                  position: 'absolute',
                  left: '0px',
                  top: '-16px',
                  userSelect: 'none',
                  border: '0px',
                  padding: '0px',
                  margin: '0px',
                  maxWidth: 'none',
                  width: '16px',
                  height: '192px'
              }} />
        </div>
     </div>
   );
};